import Box from 'app/common/MuiBox';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { oauthLogin } from 'services/auth';

import logo from 'assets/images/cse-logo-v-3x.png';

const styles = {
  paper: {
    marginTop: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: 1,
    width: 238,
    height: 'auto',
    maxWidth: '100%',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: '24px 0 16px',
  },
};

const SignIn = () => {
  return (
    <Container component="main" maxWidth="xs">
      <Box sx={styles.paper}>
        <Box component="img" sx={styles.avatar} src={logo} />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={styles.submit}
          onClick={oauthLogin}
        >
          Sign In
        </Button>
      </Box>
    </Container>
  );
};

export default SignIn;
